/* eslint-disable @typescript-eslint/ban-ts-comment */
import { openDB, DBSchema, IDBPDatabase } from 'idb';

export interface MyDB extends DBSchema {
  boxes: {
    key: number;
    value: {
      id?: number;
      name: string;
      nsn: string;
      niin: number;
      nomenclature: string;
      authorizedqty: number;
      qty: number;
      weight: number;
      length: number;
      width: number;
      height: number;
      storagetype: string;
    };
    indexes: { 'by-name': string };
  };
  boxesForEdit: {
    key: number;
    value: {
      id?: number;
      name: string;
      nsn: string;
      niin: number;
      nomenclature: string;
      authorizedqty: number;
      qty: number; //on hand qty
      weight: number;
      length: number;
      width: number;
      height: number;
      storagetype: string;
    };
    indexes: { 'by-niin': number };
  };
  distributed_items: {
    key: number;
    value: {
      id?: number;
      name: string;
      nsn: string;
      niin: number;
      nomenclature: string;
      qty: number;
      authorizedqty: number;
      weight: number;
      length: number;
      width: number;
      height: number;
      quadid: number;
      storagetype: string;
      isPlaced:boolean;
      isSkipped: boolean;
    };
    indexes: { 'by-quadid': number, 'by-nsn-nomenclature-quadid' : string };
  };
  unplaced_boxes: {
    key: number;
    value: {
      id?: number;
      name: string;
      nsn: string;
      niin: number;
      nomenclature: string;
      qty: number;
      authorizedqty: number;
      weight: number;
      length: number;
      width: number;
      height: number;
      quadid: number;
      storagetype: string;
    };
    indexes: { 'by-quadid': number };
  };

  //Containers Master - Details of all containers
  containers_master:{
    key: number;
    value: {
      id?: number;
      name: string;
      containerId: number;
      containerType: string;
      weight: number;
      no_of_quadrants: number;
      width: number;
      length: number;
      height: number;
    };
    indexes: { 'by-containerId': number }
  };

  //Placed Containers list and detils
  containers:{
    key: number;
    value: {
      id?: number;
      name: string;
      containerId: number;
      containerType: string;
      palletno: number;
      weight: number;
      no_of_quadrants: number;
      width: number;
      length: number;
      height: number;
      no_of_boxes: number;
    };
    indexes: { 'by-containerId': number }
  };
  placed_boxes: {
    key: number;
    value: {
      boxId?: number;
      name: string;
      nsn: string;
      niin: number;
      nomenclature: string;
      qty: number;
      authorizedqty: number;
      weight: number;
      length: number;
      width: number;
      height: number;
      level: number;
      levelMaxHeight: number;
      quadrantId: number;
      palletid: number;
      storagetype: string;
      position_no: number;
      x: number;
      y: number;
      z: number;
      spillNo: number;
      rotation: number;
      palletno: number;
    };
    indexes: { 'by-palletid': number };
  };
  

}

class DB {
  public db: IDBPDatabase<MyDB> | null = null;

    async init() {
    console.log("about to await db")
    this.db = await openDB<MyDB>('my-database', 1, {
      upgrade(db) {
        console.log('CREATING ObjectStore');
        if (!db.objectStoreNames.contains('boxes')) {
          const boxStore = db.createObjectStore('boxes', {
            keyPath: 'id',
            autoIncrement: true,
          });
          boxStore.createIndex('by-name', 'name');
          console.log('ObjectStore boxes created');
        }
        console.log('CREATING ObjectStore : Boxes completed');
        if (!db.objectStoreNames.contains('boxesForEdit')) {
          const boxesForEdit = db.createObjectStore('boxesForEdit', {
            keyPath: 'id',
            autoIncrement: true,
          });
          boxesForEdit.createIndex('by-niin', 'niin');
          console.log('ObjectStore boxesForEdit created');
        }
        console.log('CREATING ObjectStore : BoxesForEdit completed');

        if (!db.objectStoreNames.contains('distributed_items')) {
          const distributedStore = db.createObjectStore('distributed_items', {
            keyPath: 'id',
            autoIncrement: true,
          });
          distributedStore.createIndex('by-quadid', 'quadid');
          distributedStore.createIndex('by-nsn-nomenclature-quadid', ["nsn", "nomenclature", "quadid"], {unique: false});
          console.log('ObjectStore distributed_items created');
        }
        console.log('CREATING ObjectStore : unplaced_boxs begin');
        if (!db.objectStoreNames.contains('unplaced_boxes')) {
          const unplacedBoxesStore = db.createObjectStore('unplaced_boxes', {
            keyPath: 'id',
            autoIncrement: true,
          });
          unplacedBoxesStore.createIndex('by-quadid', 'quadid');
          console.log('ObjectStore unplaced_boxes created');
        }
        if (!db.objectStoreNames.contains('containers_master')) {
          const containers_masterStore = db.createObjectStore('containers_master', {
            keyPath: 'id',
            autoIncrement: true,
          });
          containers_masterStore.createIndex('by-containerId', 'containerId');
          console.log('ObjectStore containers_masterStore created');
        }

        if (!db.objectStoreNames.contains('containers')) {
          const containersStore = db.createObjectStore('containers', {
            keyPath: 'id',
            autoIncrement: true,
          });
          containersStore.createIndex('by-containerId', 'containerId');

          console.log('ObjectStore containers created');
        }

        console.log('CREATING ObjectStore : placed_boxes completed');
        if (!db.objectStoreNames.contains('placed_boxes')) {
          const placedBoxesStore = db.createObjectStore('placed_boxes', {
            keyPath: 'id',
            autoIncrement: true,
          });
          placedBoxesStore.createIndex('by-palletid', 'palletid');
          console.log('ObjectStore placed_boxes created');
        }
      },
    });
    console.log('DB initialized successfully');
  }

  async insertBox(
      name: string,
      nsn: string,
      niin: number,
      nomenclature: string,
      qty: number,
      authorizedqty: number,
      weight: number,
      length: number,
      width: number,
      height: number,
      storagetype: string
  ) {
    if (!this.db) {
      throw new Error('Database is not initialized');
    }
    await this.db.add('boxes', { name, nsn, niin, nomenclature, qty, authorizedqty, weight, length, width, height, storagetype });
  }

  async emptyBoxes() {
    if (!this.db) {
      throw new Error('Database is not initialized');
    }
    await this.db.clear('boxes');
    await this.db.clear('boxesForEdit');
    await this.db.clear('distributed_items');
    await this.db.clear('containers');
    await this.db.clear('placed_boxes');
    
  }

  async emptySomeBoxes() {
    if (!this.db) {
      throw new Error('Database is not initialized');
    }
    await this.db.clear('boxes');
    await this.db.clear('distributed_items');
    await this.db.clear('containers');
    await this.db.clear('placed_boxes');
  }

  async insertLeftoverBox(
      name: string,
      nsn: string,
      niin: number,
      nomenclature: string,
      qty: number,
      authorizedqty: number,
      weight: number,
      length: number,
      width: number,
      height: number,
      storagetype: string,
      callback: (err: Error | null) => void
  ) {
    if (!this.db) {
      throw new Error('Database is not initialized');
    }
    try {
      await this.db.add('distributed_items', { name, nsn, niin, nomenclature, qty, authorizedqty, weight, length, width, height, quadid: -1, storagetype,isPlaced:false,isSkipped:false });
      callback(null);
    } catch (err) {
      callback(null);
    }
  }

  async rebuildIndex (TABLE_NAME : string, INDEX_NAME: string, INDEX_KEY: string) {
    if (!this.db) {
      throw new Error('Database is not initialized');
    }
    this.db = await openDB<MyDB>('my-database', 1, {
      upgrade(db) {
      // @ts-ignore
      const transaction = this.db.transaction(TABLE_NAME, 'readwrite');
      // @ts-ignore
      const objectStore = transaction.objectStore(TABLE_NAME);

      // Check if the index exists and delete it
      // @ts-ignore
      if (objectStore && objectStore.indexNames.contains(INDEX_NAME)) {
        console.log(`Deleting existing index: by-palletid`);
        objectStore.deleteIndex('by-palletid');
      }

      // Recreate the index
      if (objectStore) {
        console.log(`Creating new index: by-palletid`);
        // @ts-ignore
        store.createIndex(INDEX_NAME, INDEX_KEY, '{ unique: false }');
      }
    }
  });
  };
  // Add other methods as needed...
}


export default DB;
